import { Component, Inject, OnInit, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DownloadStatus } from '@shared/models/download-status.model';

@Component({
    selector: 'hmt-download-dialog',
    templateUrl: './download-dialog.component.html',
    styleUrls: ['./download-dialog.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.Default  // Explicitly set to Default
})
export class DownloadDialogComponent implements OnInit {
  isExpanded = true;
  // Track the last progress to avoid backwards updates
  private lastProgress = 0;

  constructor(
    public dialogRef: MatDialogRef<DownloadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DownloadStatus,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.lastProgress = this.data.progress || 0;
  }

  /**
   * Update the dialog data and trigger change detection
   * This method should be called instead of directly mutating the data property
   */
  updateData(newData: DownloadStatus): void {
    // Prevent backwards progress updates (Firebase stale data issue)
    if (newData.progress < this.lastProgress && newData.progress !== 100) {
      return;
    }
    
    // Reset on new download (progress goes to 0)
    if (newData.progress === 0 && this.lastProgress > 0 && this.lastProgress < 100) {
      this.lastProgress = 0;
    }
    
    this.lastProgress = newData.progress;
    this.data = { ...newData }; // Create a new object reference to ensure change detection
    this.cdr.detectChanges(); // Force immediate change detection
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  toggleExpand(): void {
    this.isExpanded = !this.isExpanded;

    // Notify via callback if available
    if (this.data.onExpandStateChange && this.data.downloadType) {
      this.data.onExpandStateChange(this.data.downloadType, this.isExpanded);
    }
  }
}
